import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=400c0172&scoped=true&lang=pug&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c0172",
  null
  
)

export default component.exports